var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "analytic"
        ? _c(
            "b-card",
            [
              _c("j-analytic-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "analytic_v2"
        ? _c(
            "b-card",
            [
              _c("j-analytic2-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "board"
        ? _c(
            "b-card",
            [
              _c("j-board-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "channel"
        ? _c(
            "b-card",
            [
              _c("j-channel-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "digital_signature"
        ? _c(
            "b-card",
            [
              _c("j-digital-signature-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name === "digital_signature_workflow_requester"
        ? _c(
            "b-card",
            [
              _c("j-digital-signature-req-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name === "digital_signature_workflow_approver"
        ? _c(
            "b-card",
            [
              _c("j-digital-signature-app-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "discussion"
        ? _c(
            "b-card",
            [
              _c("j-discussion-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "form"
        ? _c(
            "b-card",
            [
              _c("j-form-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "form_ui"
        ? _c(
            "b-card",
            [
              _c("j-form-ui-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "multiple_form_ui"
        ? _c(
            "b-card",
            [
              _c("j-multiple-form-ui-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "canvas"
        ? _c(
            "b-card",
            [
              _c("j-canvas-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "formula"
        ? _c(
            "b-card",
            [
              _c("j-formula-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "hierarchy"
        ? _c(
            "b-card",
            [
              _c("j-hierarchy-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "custom_hierarchy"
        ? _c(
            "b-card",
            [
              _c("j-custom-hierarchy-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "html"
        ? _c(
            "b-card",
            [
              _c("j-html-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "widget"
        ? _c(
            "b-card",
            [
              _c("j-widget-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "workflow"
        ? _c(
            "b-card",
            [
              _c("j-workflow-req-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "workflow_approver"
        ? _c(
            "b-card",
            [
              _c("j-workflow-app-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "cost_center"
        ? _c(
            "b-card",
            [
              _c("j-cost-center-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "employee_setup"
        ? _c(
            "b-card",
            [
              _c("j-employee-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "employee_grade_setup"
        ? _c(
            "b-card",
            [
              _c("j-grade-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "position_setup"
        ? _c(
            "b-card",
            [
              _c("j-position-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "flow_setup"
        ? _c(
            "b-card",
            [
              _c("j-flow-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "location_setup"
        ? _c(
            "b-card",
            [
              _c("j-location-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "orgunit_setup"
        ? _c(
            "b-card",
            [
              _c("j-org-unit-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "payroll_area"
        ? _c(
            "b-card",
            [
              _c("j-payroll-area-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "tax_location"
        ? _c(
            "b-card",
            [
              _c("j-tax-location-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "basic_payroll_config"
        ? _c(
            "b-card",
            [
              _c("j-basic-payroll-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "company_payroll_config"
        ? _c(
            "b-card",
            [
              _c("j-company-payroll-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "component_payroll_config"
        ? _c(
            "b-card",
            [
              _c("j-component-payroll-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "employee_payslip"
        ? _c(
            "b-card",
            [
              _c("j-employee-payslip-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "personal_payslip"
        ? _c(
            "b-card",
            [
              _c("j-personal-payslip-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "run_payroll"
        ? _c(
            "b-card",
            [
              _c("j-run-payroll-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "attendance_config"
        ? _c(
            "b-card",
            [
              _c("j-attendance-config-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "attendance_monitor"
        ? _c(
            "b-card",
            [
              _c("j-attendance-monitor-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "attendance_my_log"
        ? _c(
            "b-card",
            [
              _c("j-attendance-my-log-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "attendance_report"
        ? _c(
            "b-card",
            [
              _c("j-attendance-report-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "co_attendance_approver"
        ? _c(
            "b-card",
            [
              _c("j-co-attendance-approver-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "co_attendance_monitor"
        ? _c(
            "b-card",
            [
              _c("j-co-attendance-monitor-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "co_attendance_requestor"
        ? _c(
            "b-card",
            [
              _c("j-co-attendance-requestor-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "leave_approver"
        ? _c(
            "b-card",
            [
              _c("j-leave-approver-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "leave_config"
        ? _c(
            "b-card",
            [
              _c("j-leave-config-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "leave_monitor"
        ? _c(
            "b-card",
            [
              _c("j-leave-monitor-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "leave_requestor"
        ? _c(
            "b-card",
            [
              _c("j-leave-requestor-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "leave_report"
        ? _c(
            "b-card",
            [
              _c("j-leave-report-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name === "digital_signature"
        ? _c(
            "b-card",
            [
              _c("j-digital-signature-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name === "digital_document"
        ? _c(
            "b-card",
            [
              _c("j-digital-document-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "embed_url"
        ? _c(
            "b-card",
            [
              _c("j-embed-url-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster.name.toLowerCase() === "timesheet"
        ? _c(
            "b-card",
            [
              _c("j-timesheet-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "timesheet_approval"
        ? _c(
            "b-card",
            [
              _c("j-timesheet-approval-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "timesheet_config"
        ? _c(
            "b-card",
            [
              _c("j-timesheet-config-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "timesheet_report"
        ? _c(
            "b-card",
            [
              _c("j-timesheet-report-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "advanced_form_table"
        ? _c(
            "b-card",
            [
              _c("j-bakti-table-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "dynamic_workflow"
        ? _c(
            "b-card",
            [
              _c("j-bakti-workflow-req-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate &&
          _vm.dataMaster.name.toLowerCase() === "dynamic_workflow_approver"
        ? _c(
            "b-card",
            [
              _c("j-bakti-workflow-app-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm.modeCreate && _vm.dataMaster
        ? _c(
            "b-card",
            [
              _c("j-default-setup", {
                attrs: {
                  "data-master": _vm.dataMaster,
                  "mode-create": _vm.modeCreate,
                  "mode-edit": _vm.modeEdit,
                  "data-edit": _vm.dataEdit
                },
                on: { "close-field": _vm.closeModal }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-435a43ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-435a43ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/jPagesFormSetup.vue
// module id = null
// module chunks = 